import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';
import { fetchUserAttributes } from "aws-amplify/auth";
import { apiGetUserByEmail, logoutCognitoUser, apiCreateLoginHistory } from 'apis/UserApi';
import { useNavigate } from 'react-router-dom';

const Context = createContext({});

export default function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loginHistoryRefresh, setLoginHistoryRefresh] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();

    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    }
  }, [])

  const checkAuth = async () => {
    try {
      const CONFIRM_TOTP_SETUP_STEP = localStorage.getItem('CONFIRM_TOTP_SETUP_STEP');
      const AUTO_LOGIN = localStorage.getItem('AUTO_LOGIN') === 'true';
      const LEAVE_TIME = localStorage.getItem('LEAVE_TIME');
      const LAST_ACCESS_LOGGED = localStorage.getItem('LAST_ACCESS_LOGGED');

      if (CONFIRM_TOTP_SETUP_STEP === 'true') {
        await logoutCognitoUser();
        localStorage.setItem('CONFIRM_TOTP_SETUP_STEP', false);
        navigate("/login");
      } else {
        const userAttr = await fetchUserAttributes();
        if (!AUTO_LOGIN && (new Date().getTime() - Number(LEAVE_TIME) > 5000)) {
          await logoutCognitoUser();
          return navigate("/login")
        }
        const currUser = await apiGetUserByEmail(userAttr.email);
        setCurrentUser(currUser);
        
        // ログイン保持状態でのアクセス履歴を記録
        if (AUTO_LOGIN && currUser) {
          const currentDate = new Date();
          const currentDateStr = currentDate.getFullYear().toString() + 
            (currentDate.getMonth() + 1).toString().padStart(2, '0') + 
            currentDate.getDate().toString().padStart(2, '0');
          
          const lastLoggedDateStr = LAST_ACCESS_LOGGED || '';
          
          // 日付が異なる場合のみ記録
          if (currentDateStr !== lastLoggedDateStr) {
            await apiCreateLoginHistory(currUser.id, true, null, navigator.userAgent);
            localStorage.setItem('LAST_ACCESS_LOGGED', currentDateStr);
            setLoginHistoryRefresh(prev => prev + 1);
          }
        }
      }
    }
    catch (err) {
      navigate("/login")
    }
  }

  const onBeforeUnload = () => {
    localStorage.setItem('LEAVE_TIME', new Date().getTime());
  }

  return (
    <Context.Provider value={{ currentUser, setCurrentUser, loginHistoryRefresh }}>
      {children}
    </Context.Provider>
  );
}

export const useAuth = () => useContext(Context);
